

















































































































import { Component, Vue, Provide, Prop } from "vue-property-decorator";
// import { GetOverdueListReq, GetRemindListReq } from "@/pbjs/xcommon/collection_pb.js";

import { GetPhoneSaleListReq } from "@/pbjs/xcommon/phonesale_pb.js";

import { collectionServiceClient } from "@/api";
import { localGet, timeFormat } from "@/utils";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, errorMsg, setPage } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
    name: "newOrder",
    filters: {
        filterTime(time: number) {
            function addZero(val: any) {
                if (val < 10) {
                val = "0" + val;
                }
                return val;
            }
            if (!time) {
                return time;
            }
            let date: any = new Date(time);
            let month: any = addZero(date.getMonth() + 1);
            let day: any = addZero(date.getDate());
            var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
            var hoursMS =
                addZero(date.getHours()) +
                ":" +
                addZero(date.getMinutes()) +
                ":" +
                addZero(date.getSeconds());
            return yearMonthDay + " " + hoursMS;
        }
    }
})
export default class CombinationProperty extends Vue {
    @Provide() private propList: any = []; // list
    @Provide() private token: any = ""; // token
    @Provide() private systemInfo: any = "";
    @Provide() private pageSize: any = 20; //分页页数
    @Provide() private pagerCount: any = 0; //总条数
    @Provide() private pageIndex: any = 1; //当前页
    @Prop() page:any;
    @Prop() phoneSaleItemList: any; //电销结果选择列表
    @Provide() private orderId: any = ""; //借款ID
    @Provide() private PhoneSaleItem: any = []; //选择结果
    @Provide() private mobile: any = ""; //电话
    // @Provide() private userId: any = ""; //userId
    @Provide() private isGetListActionDone: boolean = false;
    @Provide() private pagnition: any = pagnition;
    @Provide() private sortCondition: any = {
        prop: null,
        order: null
    };

    // 直达链接
    private goCollectionDetailPage(row: any) {
        console.log(row, "row");
        let routeData: any = this.$router.resolve({
            path: "orderHandleDetail",
            query: {
                id: row.ticket.relatedid,
                orderId: row.ticket.orderid,
                ticketId:row.ticket.id,
                itemId:row.ticket.itemid,

            }
        });
        window.open(routeData.href, "_blank");
    }

    private sortChange(val: any) {
        // 放款金额、分配时间、过期时间、处理次数、上次处理时间
        console.log(val, "val");
        switch (val.prop) {
            case "loanamount":
                this.sortCondition.prop = Sort.SORT_BY_AMOUNT;
                break;
            case "assigntime":
                this.sortCondition.prop = Sort.SORT_BY_ASSIGN_TIME;
                break;
            case "expirationtime":
                this.sortCondition.prop = Sort.SORT_BY_EXPIRE_TIME;
                break;
            case "handletime":
                this.sortCondition.prop = Sort.SORT_BY_DAILY_HANDLE_NUM;
                break;
            case "nexthandletime":
                this.sortCondition.prop = Sort.SORT_BY_LAST_HANDLE_TIME;
                break;
        }
        //正序或者倒序
        switch (val.order) {
            case "descending":
                this.sortCondition.order = Rank.RANK_DESC;
                break;
            case "ascending":
                this.sortCondition.order = Rank.RANK_ASC;
                break;
            default:
                this.sortCondition.order = Rank.RANK_UNSPECIFIED;
                break;
        }
        // console.log(this.sortCondition, "this.sortCondition");
        this.getList();
    }

    private created() {
        // this.userId = localStorage.getItem("userid");
        this.systemInfo = localStorage.getItem("systemInfo"); // 获取系统信息
    }

    private getGpLabel(params?: number) {
       // scope.row.isgp
    let label: any = '-';
    switch (params) {
      case 0:
        if(this.systemInfo === 'MPNPMX') {
          // mx - nanopay
          label = this.$t("ticketWrh.IsGP0")
        } else {
          label = '-'
        }
        break;
      case 1:
        label = this.$t("ticketWrh.IsGP1");
        break;
      default:
        label = '-';
        break;
    }
    return label;
  }

    // search
    private getListAction() {
        this.isGetListActionDone = true;
        this.pageIndex = 1;
        this.getList();
    }
    private getList() {
        console.log(this.page)
        if (this.page === "wait") {
            this.getOrderList(1);
        } else if(this.page === 'partially'){
            this.getOrderList(2);
        }else if(this.page === 'complete'){
            this.getOrderList(3);
        }
    }
    private getOrderList (type:any){
        const getPhoneSaleListReq: any = new GetPhoneSaleListReq();
        getPhoneSaleListReq.setCommonin(setCommon());
        getPhoneSaleListReq.setAction(type);
        getPhoneSaleListReq.setOrderid(this.orderId + "");
        getPhoneSaleListReq.setPagein(
            setPage(
                this.pageIndex,
                this.pageSize,
                this.sortCondition.prop,
                this.sortCondition.order
            )
        );
        // 为待处理并且有电销结果时
        if (type === 1 && this.PhoneSaleItem?.length !== 0){
            const lst = []
            for (let item of this.PhoneSaleItem) {
            const a = new proto.xcommon.PhoneSaleItem()
            a.setPid(item.pid)
            a.setIndex(item.index.toString())
            a.setValue("")
            lst.push(a)
            }
            getPhoneSaleListReq.setPhonesaleitemList(lst)
        }
        console.log('getPhoneSaleListReq==>',getPhoneSaleListReq);
        collectionServiceClient.getPhoneSaleList(getPhoneSaleListReq,{},
            (err: any, response: any) => {
                console.log(response);
                console.log(err);
                if (response) {
                const data: any = response.toObject();
                data.listList?.forEach((item: any) => {
                    for(let d in item) {
                        typeof d !== 'object' && item[d] === '' ? item[d] = '-' : item[d];
                    }
                    if(item.ticket) {
                        for(let t in item.ticket) {
                            item.ticket[t] === '' ? item.ticket[t] = '-' : item.ticket[t]
                        }
                    }

                })
                console.log(data, 'getPhoneSaleListReq res------------------');
                this.propList = data.listList;
                this.pagerCount = data.pageout.total;
                if (err) {
                    errorMsg(err);
                }
                this.isGetListActionDone = false;
            }
        });
    }
    private mounted() {
        let that = this;
        that.token = localGet("token");
        that.getList();
    }

    private handleCurrentChange(val: any) {
        this.pageIndex = Number(val);
        //展示表格数据
        this.getList();
    }

    //点击上一页
    private handlePrevChange(val: any) {
        if (this.pageIndex > 0) {
        //展示表格数据
        this.getList();
        }
    }

    //点击下一页
    private handleNextChange(val: any) {
        //展示表格数据
        this.getList();
    }

    private handleSizeChange(val: any) {
        this.pageSize = Number(val);
        //展示表格数据
        this.getList();
    }
}
